import styled from 'styled-components';
import { colors } from '../theme/helpers';

const DiscordButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  background-color: ${colors.socialsDiscord};
  border: none;
  color: white;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  padding: 0.1rem;
  font-weight: bold;
  width: 220px;
  img {
    background-color: ${colors.socialsDiscord};
    width: 22px;
  }
  a {
    text-decoration: none;
    color: white;
    margin-left: 1rem;
  }
`;

export default DiscordButton;
